import {addCircularTabFocus, focusElement, hookToAttributeSelector} from '@wix/panda-js-utils'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {StyledButton} from '../../styled-button'
import {classes} from '../error-modal.st.css'
import {SomethingWentWrongProps} from './interfaces'

export const SomethingWentWrong = ({close, tryAgainClick}: SomethingWentWrongProps) => {
  const {t} = useTranslation()
  const {isMobile} = useEnvironment()

  React.useEffect(() => {
    focusElement({selector: hookToAttributeSelector(DH.MODAL_TITLE)})
    addCircularTabFocus(hookToAttributeSelector(DH.CLOSE_BUTTON), hookToAttributeSelector(DH.TRY_AGAIN_BUTTON))
  }, [])

  return (
    <div className={classes.container}>
      <div className={classNames(classes.content, {[classes.desktopContent]: !isMobile})}>
        <div className={classes.text}>
          <Text
            data-hook={DH.MODAL_TITLE}
            tagName="h2"
            className={classNames(classes.title, {[classes.mobileTitle]: isMobile})}
          >
            {t('seatings_somethingWentWrongModal_title')}
          </Text>
        </div>
        <div className={classes.buttonContainer}>
          <StyledButton onClick={() => close()} fullWidth={false} secondary={true} dataHook={DH.CLOSE_BUTTON}>
            {t('seatings_somethingWentWrongModal_closeButton')}
          </StyledButton>
          <StyledButton onClick={() => tryAgainClick()} fullWidth={false} dataHook={DH.TRY_AGAIN_BUTTON}>
            {t('seatings_somethingWentWrongModal_tryAgainButton')}
          </StyledButton>
        </div>
      </div>
    </div>
  )
}
